import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { InvoicesService } from '../../services/invoices.service';
import { PDFService } from '../../services/pdf.service';
import { ConnectionService } from 'src/app/services/connection.service';
import { Task, TaskStatus } from '@contracts/interfaces/task.interface';

@Component({
  selector: 'app-pdf-tests',
  templateUrl: './pdf-tests.component.html',
  styleUrls: ['./pdf-tests.component.scss']
})
export class PDFTestsComponent implements OnInit, AfterViewInit {

  @ViewChild('frame', { static: false }) frameRef?: ElementRef<HTMLDivElement>;
  @ViewChild('viewerWrapper', { static: false }) viewerWrapperRef?: ElementRef<HTMLDivElement>;

  public frameHeight = 0;
  public frameWidth = 0;


  public pdfSrc: string = null;
  public htmlSrc: string;
  public pdfSrcDownload: string;
  public fileName: string;

  public currentState = "no-generated";
  public message = "";


  public template: string = "task-sheet";
  public data: any = {
    "number": 398489,
    "customer": {
        "business": "UBT Australia",
        "address": "33 Abel St, Golden Square VIC 3555",
        "phone": "",
        "email": "gavin.killackey@ubteam.com"
    },
    "date": "20-01-2026",
    "dueDate": "27-01-2026",
    "dueAmount": 35000,
    "lineItems": [
        {
            "item": "Samsung S3 Ultra",
            "desc": "Cracked back glass. Camera not functioning.",
            "qty": 1,
            "price": 15000,
            "total": 15000
        },
        {
            "item": "Samsung S22",
            "desc": "Scuff marks around edge. Battery good. Screen & Back glass good. Tested 100%.",
            "qty": 1,
            "price": 20000,
            "total": 20000
        }
    ]
};

  constructor(
    private pdfService: PDFService, 
    private invoiceService: InvoicesService,
    private connectionService: ConnectionService) { }


  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.updateFrameSize();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.updateFrameSize();
  }

  private updateFrameSize(): void {
    const wrapperTop = this.viewerWrapperRef?.nativeElement.getBoundingClientRect().top ?? 0;
    const availableHeight = Math.max(window.innerHeight - wrapperTop - 16, 200);
    const aspectRatio = 210 / 297; // A4 width/height
    this.frameHeight = availableHeight;
    this.frameWidth = Math.min(availableHeight * aspectRatio, this.viewerWrapperRef?.nativeElement.clientWidth || availableHeight * aspectRatio);
  }

  refresh () {
    this.currentState = "generating";

    this.pdfService.check(this.template, this.data).subscribe((result: any) => {       
      if (result.filename != null) {
        this.currentState = null;
        this.pdfSrc = "http://autopilot:3000/pdf-service/view?file="+result.filename+"&i=" + Date.now();
      } else {
        this.currentState = "";
        this.message = "";
      }
    })

  }

  generateTestPDF() {

    this.data.date = new Date();

    this.currentState = "generating";
    this.pdfService.url(this.template, this.data, (r) => {
      this.pdfSrc = r;

      this.currentState = "generated";
    }, false);
  }

  print() {
    this.pdfService.print(this.template, this.data, (r) => {})
  }

  view() {
    this.pdfService.view(this.template, this.data, (r) => {})
  }

  download() {
    this.pdfService.download(this.template, this.data, "test", (r) => {})
  }

}
